module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.$route.params.title
    }
  }), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "list",
      on: {
        "click": function($event) {
          _vm.toDetail(item.item_id)
        }
      }
    }, [_c('div', {
      staticClass: "list-top flex vux-1px-b"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "timer"
    }, [_c('clocker', {
      attrs: {
        "slot": "value",
        "time": _vm._f("endTimer")(item.activity_end)
      },
      slot: "value"
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "content flex"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticClass: "img-block",
      attrs: {
        "src": item.groupbuy_image,
        "default-src": "static/placeholder.png",
        "container": "#vux_view_box_body"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-1 text-l flex r"
    }, [_c('h1', {
      staticClass: "ellipsis-2"
    }, [_vm._v(_vm._s(item.groupbuy_title))]), _vm._v(" "), _c('p', {
      staticClass: "des color-666 flex-1"
    }, [_vm._v(_vm._s(item.groupbuy_desc))]), _vm._v(" "), _c('div', {
      staticClass: "flex btm"
    }, [_c('div', [_c('span', {
      staticClass: "groud-num"
    }, [_vm._v(_vm._s(item.groupbuy_num) + "人拼团省￥" + _vm._s(item.save))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "price"
    }, [_vm._v("￥" + _vm._s(item.groupbuy_price))]), _vm._v(" "), _c('del', [_vm._v("￥" + _vm._s(item.price))])])]), _vm._v(" "), _c('button', [_vm._v("去拼团")])])])])])
  }), _vm._v(" "), (_vm.list.length == 0) ? _c('not-data') : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "iconfont"
  }), _vm._v("距离结束")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-506f3dfc"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeSpellGroup/HomeSpellGroup.vue
// module id = 563
// module chunks = 0